import { onUpdated, watch, nextTick, type Ref } from 'vue'

/**
 * 특정 DOM 요소가 업데이트된 후 실행하는 커스텀 훅
 *
 * @param elementRef - 감지할 DOM 요소의 ref
 * @param callback - 요소가 렌더링된 후 실행할 콜백 함수
 */
export const useAfterRender = (
  elementRef: Ref<null | HTMLElement>,
  callback: () => void
) => {
  // Watch 및 DOM 업데이트 타이밍에서 실행
  const executeAfterUpdate = async () => {
    await nextTick() // DOM 업데이트 이후 호출
    if (elementRef.value) {
      callback()
    }
  }

  // 리액티브 상태 또는 렌더링 후 실행
  onUpdated(() => {
    executeAfterUpdate()
  })

  // 요소(ref)에 직접 반응할 수도 있도록 설정
  watch(elementRef, (newValue) => {
    if (newValue) {
      executeAfterUpdate()
    }
  })
}
